import type { CpapOption } from '@common/enums';
import type { OsasAllTreatmentsData, TreatmentData } from '../osasAllTreatmentsSchemas/types';
import type { TherapielandProgramSelectionFields } from '../osasConsultSchemas/types';

export enum FollowupPerformer {
    medicalSpecialist = 'medisch specialist',
    osasConsultant = 'OSAS consulent',
}

export type FollowupData = {
    hide?: boolean;
    performer: FollowupPerformer;
    weeks: number;
};
export type TreatmentFollowUpData = {
    CPAP: FollowupData[];
    MRA: FollowupData[];
    SPT: FollowupData[];
};

export type referData = {
    conclusion: string | null;
    department: string | null;
    message: string | null;
    organization: string | null;
    question: string | null;
    reason: string | null;
    specialismName: string | null;
    subject: string | null;
};

export type OsasTreatmentData = {
    adviceGeneralPractitionerForOsa: string | null;
    allTreatments: OsasAllTreatmentsData;
    cpapSetting: CpapOption | null;
    cpapSettingText: string | null;
    refer: referData;
    remarkTreatment: string | null;
    resendQuestionnaires: boolean | null;
    resendQuestionnairesWeeks: number | null;
    shouldHaveFollowingExamination: boolean | null;
    shouldHaveFollowUpConsult: boolean | null;
    taskFollowingExaminationOrConsultWeeks: number | null;
    taskForPoliclinic: string | null;
    treatment: TreatmentData;
    treatmentFollowUp: TreatmentFollowUpData;
};

export type OsasTreatmentBreakData = {
    treatmentToBreak: Array<keyof TreatmentData>;
    treatmentToBreakRemark: string | null;
};

export type OsasTreatmentChoiceCustomControlData = OsasTreatmentData &
    OsasTreatmentBreakData &
    TherapielandProgramSelectionFields & {
        remarkOther: string | null;
    };
